import React, { useState, useEffect, useRef } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import IconButton from '@mui/material/IconButton';
import { addDoc, collection, query, where, getDocs } from 'firebase/firestore'; // Import Firestore functions
import { db } from '../../firebase';
import bcrypt from 'bcryptjs';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function AddUserForm({ open, setOpen,setLoading }) {

    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [formValues, setFormValues] = useState({ username: '', password: '', confirmPassword: '' });


    const handleClose = () => {
        setOpen(false);
    };

    const handleClickShowPassword = (isConfirmPassword) => {
        setShowPassword((prev) => !prev);
    };
    const handleClickShowConfirmPassword = (isConfirmPassword) => {
        setShowConfirmPassword((prev) => !prev);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormValues((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const notify = (message) => {
        toast.error(message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,


        });
    };
    const successNotify = (message) => {
        toast.success(message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,


        });
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        handleClose();
        setLoading(true);
        const { username, password, confirmPassword } = formValues;

        // Perform validation (e.g., password match)
        if (password !== confirmPassword) {
            setLoading(false);
            notify("Passwords do not match");
            return;
        }

        // Check if the username is already taken
        const usersRef = collection(db, "users");
        const q = query(usersRef, where("username", "==", username));
        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
            setLoading(false);
            notify("Username already exists! Please choose another one.");
            return;
        }

        // Add user to Firestore
        let hashedPassowrd = await hashPassword(password);
        try {
            const docRef = await addDoc(usersRef, {
                username: username,
                password: hashedPassowrd,
                is_admin: false // Ideally, you should hash the password before storing it.
            });
            console.log("User added with ID: ", docRef.id);
            setLoading(false);
            successNotify('User added successfully');
             // Close the dialog after successful addition
        } catch (e) {
            console.error("Error adding user: ", e);
            setLoading(false);
            notify('Error while adding user');
        }
    };

    const hashPassword = async (password) => {
        // Define the salt rounds (higher means more secure but slower)
        const saltRounds = 10;

        try {
            // Generate a salt and hash the password with it
            const hashedPassword = await bcrypt.hash(password, saltRounds);
            console.log('Hashed Password:', hashedPassword);

            // You can now send this hashed password to your backend
            return hashedPassword;
        } catch (error) {
            notify('An error occurred. Please try again.');
            console.error('Error hashing password:', error);
        }
    };

    return (
        <React.Fragment>
            {/* <Button variant="outlined" onClick={handleClickOpen}>
                Open form dialog
            </Button> */}
            <Dialog
                open={open}
                onClose={handleClose}
                PaperProps={{
                    component: 'form',
                    onSubmit: handleSubmit,
                    sx: {
                        bgcolor: 'rgba(0,0,0,0.9)', // Set the background color here
                        padding: 2, 
                        border: '1px solid white',// Optional padding
                        borderRadius:'10px'
                    }

                }}
            >
                <DialogTitle sx={{ color: 'white' }}>Add New User</DialogTitle>
                <DialogContent>
                    <DialogContentText sx={{ color: 'rgba(255,255,255,0.5)' }}>
                        By adding users, you can grant them permission to perform actions related to door access, such as unlocking, monitoring, and managing the door's activity.
                    </DialogContentText>
                    <TextField
                        autoFocus
                        required
                        margin="dense"
                        id="username"
                        name="username"
                        label="Username"
                        type="username"
                        fullWidth
                        variant="standard"
                        onChange={handleChange}
                        InputProps={{
                            sx: {
                                color: 'rgba(255,255,255,0.6)', 
                              '&:before': {
                                borderBottomColor: 'rgba(255,255,255,0.5)', // Default border color
                              },
                              '&:hover:not(.Mui-disabled):before': {
                                borderBottomColor: 'rgba(255,255,255,1)', // Hover border color
                              },
                              '&:after': {
                                borderBottomColor: 'rgba(255,255,255,0.7)', // Focused border color
                              },
                            },
                          }}
                          InputLabelProps={{
                            sx: {
                              color: 'rgba(255,255,255,0.5)', // Default label color
                              '&.Mui-focused': {
                                color: 'white', // Change label color to white when focused
                              },
                            },
                          }}
                    />
                    <TextField
                        autoFocus
                        required
                        margin="dense"
                        id="password"
                        name="password"
                        label="Password"
                        type={showPassword ? 'text' : 'password'}
                        fullWidth
                        variant="standard"
                        InputProps={{
                            sx: {
                                color: 'rgba(255,255,255,0.6)', 
                                '&:before': {
                                  borderBottomColor: 'rgba(255,255,255,0.5)', // Default border color
                                },
                                '&:hover:not(.Mui-disabled):before': {
                                  borderBottomColor: 'rgba(255,255,255,1)', // Hover border color
                                },
                                '&:after': {
                                  borderBottomColor: 'rgba(255,255,255,0.7)', // Focused border color
                                },
                              },
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        onClick={handleClickShowPassword}
                                        onMouseDown={handleMouseDownPassword}
                                        edge="end"
                                    >
                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                        InputLabelProps={{
                            sx: {
                              color: 'rgba(255,255,255,0.5)', // Default label color
                              '&.Mui-focused': {
                                color: 'white', // Change label color to white when focused
                              },
                            },
                          }}
                        onChange={handleChange}
                    />
                    <TextField
                        autoFocus
                        required
                        margin="dense"
                        id="confirmPassword"
                        name="confirmPassword"
                        label="Confirm Password"
                        type={showConfirmPassword ? 'text' : 'password'}
                        fullWidth
                        variant="standard"
                        InputProps={{
                            sx: {
                                color: 'rgba(255,255,255,0.6)', 
                                '&:before': {
                                  borderBottomColor: 'rgba(255,255,255,0.5)', // Default border color
                                },
                                '&:hover:not(.Mui-disabled):before': {
                                  borderBottomColor: 'rgba(255,255,255,1)', // Hover border color
                                },
                                '&:after': {
                                  borderBottomColor: 'rgba(255,255,255,0.7)', // Focused border color
                                },
                              },
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        onClick={handleClickShowConfirmPassword}
                                        onMouseDown={handleMouseDownPassword}
                                        edge="end"
                                    >
                                        {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                        InputLabelProps={{
                            sx: {
                              color: 'rgba(255,255,255,0.5)', // Default label color
                              '&.Mui-focused': {
                                color: 'white', // Change label color to white when focused
                              },
                            },
                          }}
                        onChange={handleChange}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button type="submit">Add</Button>
                </DialogActions>
            </Dialog>
            <ToastContainer />
        </React.Fragment>
    );
}